import { motion } from 'framer-motion'
import { Sparkles, Building2, Loader2 } from 'lucide-react'
import { CaseStatusCard } from './CaseStatusCard'

interface CaseStatusTabProps {
  caseId: number
  aiSummary?: string | null
  defendantAirlineCode?: string | null
  defendantAirlineName?: string | null
  onGenerateDocument: (templateType: string) => Promise<void>
  onOpenActionModal: (preselectedActionType?: string) => void
  generatingDocType?: string | null
}

export function CaseStatusTab({
  caseId,
  aiSummary,
  defendantAirlineCode,
  defendantAirlineName,
  onGenerateDocument,
  onOpenActionModal,
  generatingDocType,
}: CaseStatusTabProps) {
  return (
    <div className="space-y-6">
      {/* AI Summary Card */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden"
      >
        <div className="p-5">
          <div className="flex items-center gap-2 mb-3">
            <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-purple-100">
              <Sparkles className="h-4 w-4 text-purple-600" />
            </div>
            <h3 className="font-semibold text-slate-900">KI-Zusammenfassung</h3>
          </div>

          {aiSummary ? (
            <p className="text-slate-700 text-sm leading-relaxed">{aiSummary}</p>
          ) : (
            <div className="flex items-center gap-2 text-slate-400">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span className="text-sm italic">Zusammenfassung wird generiert...</span>
            </div>
          )}

          {/* Defendant info */}
          {defendantAirlineName && (
            <div className="mt-4 pt-4 border-t border-slate-100">
              <div className="flex items-center gap-2">
                <Building2 className="h-4 w-4 text-slate-400" />
                <span className="text-sm text-slate-600">
                  <span className="font-medium">Beklagter:</span>{' '}
                  {defendantAirlineName}
                  {defendantAirlineCode && (
                    <span className="text-slate-400 ml-1">({defendantAirlineCode})</span>
                  )}
                </span>
              </div>
            </div>
          )}
        </div>
      </motion.div>

      {/* Existing Status Card */}
      <CaseStatusCard
        caseId={caseId}
        onGenerateDocument={onGenerateDocument}
        onOpenActionModal={onOpenActionModal}
        generatingDocType={generatingDocType}
      />
    </div>
  )
}
